
class ButtonData {

  constructor(props) {
    this.choice = props.choice;
    this.label = this.choiceToLabel(props);
  };

  getChoice() {
    return this.choice
  }

  getLabel() {
    return this.label
  }

  choiceToLabel(props) {
    let noteInfo = this.choice.match(/^(\w)(\d)(.*)/);
    let note = noteInfo[1];
    let register = noteInfo[2];
    let accidental = noteInfo[3];
    if (accidental === 'flat') {
      note = note + String.fromCharCode(0x266d)
    }
    if (accidental === 'sharp') {
      note = note + String.fromCharCode(0x266f)
    }
    const label = note + register
    return label;
  }

}

export default ButtonData;

